





























































































































import { ParagraphSize, SkeletonType } from '@getaccept/lib-ui';
import type { Document } from '@getaccept/lib-shared/src/types/Document';
import type { User } from '@getaccept/lib-shared/src/users/types/user';
import { StatusHelper } from '@getaccept/lib-shared/src/helpers/status.helper';
import { defineComponent, computed, watch } from '@vue/composition-api';
import type { PropType } from '@vue/composition-api';
import type {
  SearchResult as ISearchResult,
  HighlightedSearchResultItem,
} from '../types/search-result';
import { SearchResultType } from '../types/enums/search-result-type';
import EmptySearch from '../../../assets/illustrations/empty-search.svg';

export default defineComponent({
  components: {
    EmptySearch,
  },
  props: {
    result: { type: Object as PropType<ISearchResult>, default: null },
    highlightedItem: { type: Object as PropType<HighlightedSearchResultItem>, default: null },
    loading: { type: Boolean },
  },
  setup(props, { emit }) {
    const hasResult = computed(() => !!contacts.value.length || !!documents.value.length);
    const contacts = computed(() => props.result?.contacts || []);
    const documents = computed(() => props.result?.documents || []);

    const isItemHighlighted = (type: SearchResultType, index: number) =>
      props.highlightedItem.type === type && props.highlightedItem.index === index;

    const getNormalizedCellContent = (content: string) => content || '-';

    const selectContact = (contact: User) => emit('selectContact', contact);

    const selectDocument = (document: Document) => emit('selectDocument', document);

    watch(
      () => props.highlightedItem,
      () => watchHighlightedItem(),
      { deep: true }
    );

    const watchHighlightedItem = () => {
      const elementId: string =
        props.result[props.highlightedItem.type][props.highlightedItem.index]?.id;
      if (!elementId) {
        return;
      }
      const highlightedElement: HTMLElement = document.getElementById(elementId);
      if (highlightedElement) {
        highlightedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };

    return {
      SearchResultType,
      getDocumentHasBadgeBorder: StatusHelper.getDocumentHasBadgeBorder,
      getDocumentStatusTranslation: StatusHelper.getDocumentStatusTranslation,
      getDocumentStatusType: StatusHelper.getDocumentStatusType,
      ParagraphSize,
      SkeletonType,
      hasResult,
      contacts,
      documents,
      isItemHighlighted,
      getNormalizedCellContent,
      selectContact,
      selectDocument,
      watchHighlightedItem,
    };
  },
});
